import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiServices } from 'src/app/shared/services/api.service';
import { DataService } from 'src/app/shared/services/data.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-accessories',
  templateUrl: './accessories.component.html',
  styleUrls: ['./accessories.component.scss']
})
export class AccessoriesComponent implements OnInit, OnDestroy {
  private subs = new Subscription();
  categories: Array<any> = [];
  addOns: Array<any> = [];
  is_hide_cost:any;
  isLoading = false;
  isLoadingMore = false;
  inventoryData:any = []
  warehouse_quantity:any = {};
  clickedAccessoryID:number = null;

  currentFragment = 'wheel-accessories';

  total = 0;
  from = 0;
  to = 0;

  currentPage = 1;

  queryParams = {
    perPage: 30,
    sortBy: ''
  };

  hasNextPage = false;

  filters = [];
  showFirstIcon = true;

  constructor(
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiServices,
    private helperService: HelperService,
    private toastr: ToastrService
  ) {
    this.is_hide_cost = localStorage.getItem("is_hide_cost")
    this.helperService.setPageTitle(activatedRoute.snapshot.data.title);
  }

  ngOnInit(): void {
    this.subs.add(
      this.activatedRoute.fragment.subscribe(frag => {
        this.currentPage = 1;
        this.queryParams = { ...{
          perPage: 30,
          sortBy: ''
        }, ...(this.activatedRoute.snapshot.queryParams || {})};
        this.total = 0;
        this.from = 0;
        this.to = 0;
        this.addOns = [];
        this.currentFragment = frag || this.currentFragment;
        this.getAddOns();
        this.getFilters();
      })
    );

    this.dataService.getAddOnCategories().then((categories: Array<any>) => {
      this.categories = categories;
    });
  }

  getAddOns(loadMore = false) {
    if(!loadMore) {
      this.addOns = [];
      this.isLoading = true;
    }
    if ( this.queryParams.sortBy == '' ) {
      delete this.queryParams["sortBy"];
    }
    this.apiService.getAddOnsByCategory(this.currentFragment, {...this.queryParams, page: this.currentPage}).subscribe(res => {
      this.isLoading = false;
      this.isLoadingMore = false;
      if(!loadMore) {
        this.addOns = res.data.data;
      } else {
        this.addOns = [...this.addOns, ...res.data.data];
      }
      this.total = res.data.total;
      this.from = res.data.from;
      this.to = res.data.to;

      if (res.data.next_page_url) {
        this.hasNextPage = true;
      } else {
        this.hasNextPage = false;
      }
    }, (err) => {
      this.isLoading = false;
      this.isLoadingMore = false;
    })
  }

  setWarehouse(asseccory_id:number, warehouse_id) {
    this.warehouse_quantity['warehouse_id'] = warehouse_id;
    this.warehouse_quantity['quantity'] = 1;
    this.warehouse_quantity['accessory'] = asseccory_id;
  }

  addToCart(accessory_id:number, event:Event){
    let btn = event.target as HTMLInputElement;
    let closestContainer = btn.closest('.qty-cartbtn-container');
    let quantityField = closestContainer.querySelector('.quantity-field') as HTMLInputElement;
    let userQty = parseInt(quantityField.value);
    const addOn = this.addOns.find(addOn => addOn.id === accessory_id);
    let item = {add_on_id: accessory_id, quantity: userQty}
    if (accessory_id === this.warehouse_quantity['accessory']) {
      delete this.warehouse_quantity["accessory"]
      item["warehouse_qunatity"] = [this.warehouse_quantity]
    }


    if (userQty > addOn.total_quantity) {
      this.toastr.error(`Invalid Quantity, only ${addOn.total_quantity} quantity left`, 'Error');
    } else {
      const session_id = localStorage.getItem('session_id');
      const data = {
        session_id,
        type: "addon_added_to_cart_directly",
        items: [item],
      };
  
      this.subs.add(
        this.apiService.addToCart(data).subscribe(
          response => {
            if (response.status) {
              this.apiService.getCart().subscribe(response => {
                if (response.status) {
                  this.dataService.setCartData(response);
                }
              });
              this.toastr.success(response.message, 'Success');
            }
          }, error => {
            this.toastr.error(error.error.message, 'Error');
          }
        )
      );
    }
  }

  getAddonByAccessory(accessory_id){
    let inventory_loader = document.querySelector(".inventory_loader") as HTMLElement;
    let inventory_table = document.querySelector(".inventory_table") as HTMLElement;
    inventory_table.style.display = "none";
    inventory_loader.classList.remove("d-none");
    inventory_loader.classList.add("d-flex");
    this.inventoryData = [];
    this.apiService.getAddonByAccessory(accessory_id).subscribe(
      response => {
        inventory_table.style.display = "block";
        inventory_loader.classList.remove("d-flex");
        inventory_loader.classList.add("d-none");
        this.clickedAccessoryID = accessory_id;
        this.inventoryData = response.data.inventory;
      }
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  changePerPage(event: any): void {
    this.currentPage = 1;
    this.queryParams = { ...this.queryParams, perPage: event.target.value };
    this.updateUrlAndFetchAddOns();
  }

  changeSort(event: any): void {
    this.queryParams = { ...this.queryParams, sortBy: event.target.value };
    this.updateUrlAndFetchAddOns();
  }

  loadMore(): void {
    this.isLoadingMore = true;
    this.currentPage += 1;
    this.getAddOns(true);
  }

  getFilters(): void {
    this.apiService.getAddOnFilters(this.queryParams, this.currentFragment).subscribe(response => {
      this.filters = response.data.filters;
    });
  }

  onFilter(event: any): void {
    if (event.clear) {
      event.allValues.forEach(value => delete this.queryParams[value]);
    }

    this.queryParams = { ...this.queryParams, ...event.selectedFilters };
    this.updateUrlAndFetchAddOns();
  }

  notifyWhenAvailable(addonId: any){
    this.apiService.notifyAddonsWhenAvailable(addonId).subscribe((response)=>{
      this.toastr.success(response.message, 'Success');
    })
  }

  private updateUrlAndFetchAddOns(): void {
    this.router.navigate(['./'], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      fragment: this.currentFragment
    });

    this.getAddOns();
  }
  toggleIcon() {
    this.showFirstIcon = !this.showFirstIcon;
  }
  quantity: number = 1;
  minQuantity: number = 1;

  incrementQuantity(event: Event) {
    let targetElm = event.target as HTMLElement;
    let currentQty = this.getQtyValue(targetElm);
    currentQty += 1;
    this.setQtyValue(targetElm, currentQty);
  }

  decrementQuantity(event:Event) {
    let targetElm = event.target as HTMLElement;
    let currentQty = this.getQtyValue(targetElm);

    if (currentQty > this.minQuantity) {
      currentQty -= 1;
    }
    this.setQtyValue(targetElm, currentQty);
  }

  getQtyValue(element){
    let inputBox = element.closest(".custom-adder") as HTMLElement;
    let qtyBox = inputBox.querySelector(".quantity-field") as HTMLInputElement;
    return parseInt(qtyBox.value);
  }

  setQtyValue(element, newQty){
    let inputBox = element.closest(".custom-adder") as HTMLElement;
    let qtyBox = inputBox.querySelector(".quantity-field") as HTMLInputElement;
    qtyBox.value = newQty;
  }
}
